var YMK = YMK || {};
var site = site || {};
var prodcat = prodcat || {};

(function ($) {
  Drupal.behaviors.productVtoV1 = {
    isMobile: false,
    isTablet: false,
    isTabletLandscape: false,
    unisonDependent: true,
    unisonReady: false,
    skipEventListener: false,
    hasVtoDiscloseParam: false,
    autoTriggerYoucam: false,
    selectors: {
      body: 'body',
      youcamButton: '.js-youcambtn',
      ymkModuleCont: '.js-product-vto-container',
      mobileShadePick: '.js-product-vto-mobile-ctrl',
      mobileShadePicker: '.js-shade-picker-vto',
      mobileSwatches: '.js-swatch',
      desktopSwatches: '.js-product-full_shade',
      addToBagContainer: '.js-product-vto-cart',
      addToBag: '.js-product-add-to-bag',
      prevCar: '.js-product-vto-shades-prev',
      nextCar: '.js-product-vto-shades-next',
      stickyNav: '.js-site-header',
      stickyFooter: '.js-site-footer',
      product: '.js-product-full',
      productArticle: '.js-spp-product-layout-v2',
      productImages: '.js-product-full-media',
      productFullImages: '.js-product-full__image',
      shadesGrid: '.js-spp-shades-grid',
      shadesContainer: '.js-product-full__shades-container',
      chatLiveButton: '.LPMcontainer',
      slideBagButton: '.ins-preview-wrapper'
    },
    youcamEvents: [
      'cameraClosed',
      'cameraFailed',
      'cameraOpened',
      'compare',
      'compareDisabled',
      'chooseModelEntered',
      'chosenModel',
      'closed',
      'engineClosed',
      'liveCameraEntered',
      'loaded',
      'loading',
      'kissDetected',
      'opened',
      'photoLoaded',
      'photoSaved',
      'reset',
      'share',
      'uploadPhotoEntered',
      'videoLoaded',
      'shadeFinderStarted',
      'shadeFinderComplete',
      'shadeFinderCancelled',
      'zoom',
      'modelLoaded',
      'skinAnalysisUpdated',
      'split4Way',
      'split4WayDisabled'
    ],
    attach: function (context) {
      var self = this;
      var $productVTO = $('.js-product-vto-v1', context);
      var youcamAPIKey = Drupal.settings.vto.api_key;
      var youcamAPIUrl = Drupal.settings.vto.api_url;

      if (self.attached || !$productVTO.length) {
        return;
      }

      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      // if Unison is not ready on attach, it triggers change on initialization
      if (!!Unison.fetch.now()) {
        self.unisonReady = true;
        self.checkDeviceType();
      }

      self.attached = true;

      $productVTO.each(function () {
        var $this = $(this);

        $productVTO.length === 1 ? (window.currentYMKcontext = $this) : null;
        self.getDom($this, context);
        self.getSettings($this);
        self.setEvents($this);
      });
      // seting up the window global youcam method
      self.setup();
    },
    getDom: function ($that, context) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$body = $(self.selectors.body, context);
      $that.nodes.$ymkModuleCont = $(self.selectors.ymkModuleCont, $that);
      $that.nodes.$mobileShadePick = $(self.selectors.mobileShadePick, $that);
      $that.nodes.$mobileShadePicker = $(self.selectors.mobileShadePicker, $that);
      $that.nodes.$mobileSwatches = $(self.selectors.mobileSwatches, $that);
      $that.nodes.$desktopSwatches = $(self.selectors.desktopSwatches, $that);
      $that.nodes.$addToBagContainer = $(self.selectors.addToBagContainer, $that);
      $that.nodes.$addToBag = $(self.selectors.addToBag, $that);
      $that.nodes.$prevCar = $(self.selectors.prevCar, $that);
      $that.nodes.$nextCar = $(self.selectors.nextCar, $that);
      $that.nodes.$stickyNav = $(self.selectors.stickyNav, context);
      $that.nodes.$stickyFooter = $(self.selectors.stickyFooter, context);

      $that.nodes.$product = $that.closest(self.selectors.product);
      $that.nodes.$youcamButton = $(self.selectors.youcamButton, $that.nodes.$product);
      $that.nodes.$productArticle = $(self.selectors.productArticle, context);
      $that.nodes.$productImages = $(self.selectors.productImages, context);
      $that.nodes.$productFullImages = $(self.selectors.productFullImages, context);
      $that.nodes.$shadesGrid = $(self.selectors.shadesGrid, context);
      $that.nodes.$shadesContainer = $(self.selectors.shadesContainer, context);
      $that.nodes.$chatLiveButton = $(self.selectors.chatLiveButton, context);
      $that.nodes.$slideBagButton = $(self.selectors.slideBagButton, context);
      $that.nodes.$currentPattern = $('.js-product-vto__pattern-showcase', $that);
      $that.nodes.$patternList = $('.js-product-vto__pattern-list', $that);
    },
    getSettings: function ($that) {
      $that.settings = {};
      $that.settings.productHexes = $that.nodes.$productArticle.data('productHexCodes');
    },
    setEvents: function ($that) {
      var self = this;
      var currentSkuPcode;
      var ykmWidth;

      self.renderHexCodesVTO($that);
      $that.nodes.$mobileSwatches = $that.nodes.$mobileShadePicker.find('.js-swatch');
      $that.nodes.$desktopSwatches = $that.nodes.$shadesContainer.find('.js-product-full_shade');
      $that.nodes.$shadesGrid = $that.nodes.$shadesContainer.find('.js-spp-shades-grid');
      var $firstSwatch = $that.nodes.$mobileSwatches.first();
      var $lastSwatch = $that.nodes.$mobileSwatches.last();

      Unison.on('change', function () {
        var isModuleLoaded = $that.find('#YMK-module-iframe').length > 0;
        var isModuleVisible = $that.find('.js-product-vto-container').is(':visible');
        self.checkDeviceType();
        ykmWidth = $that.width();
        if (typeof window.YMK.close === 'function' && isModuleLoaded && isModuleVisible) {
          self.reopenOnResize($that);
        }
        self.setOverlayDimensions($that, ykmWidth);
      });

      $that.nodes.$youcamButton.once().on('click', function (e) {
        e.preventDefault();
        self.openYoucamModule($that);
      });

      $that.nodes.$mobileSwatches
        .add($that.nodes.$desktopSwatches)
        .once()
        .on('click', function () {
          var $this = $(this);
          var skuBaseId = $this.data('sku-base-id');
          skuBaseId = !skuBaseId ? $that.nodes.$product.data('skuBaseId') : skuBaseId;
          var $thisParent = $this.closest('.js-custom-kit-product');

          if ($thisParent.hasClass('js-custom-kit-product-redesign')) {
            $thisParent.trigger('product.skuSelect', skuBaseId);
            if (!self.isMobile) {
              $thisParent.trigger('product.updateRoute', skuBaseId);
            }
          } else {
            $that.nodes.$product.trigger('product.skuSelect', [skuBaseId, $this]);
            if (!self.isMobile) {
              $that.nodes.$product.trigger('product.updateRoute', skuBaseId);
            }
          }
        });

      $(document).on('click', '.js-kit-product-shade, .js-shade-select-option', function () {
        var $selected = $(this);
        var skuBaseId = $selected.attr('data-sku-base-id');
        var $thisParent = $selected.closest('.js-custom-kit-product');

        $thisParent.trigger('product.skuSelect', skuBaseId);
        if (!self.isMobile) {
          $thisParent.trigger('product.updateRoute', skuBaseId);
        }
      });

      $that.once().on(
        'click',
        '.js-product-vto-pattern-button',
        function (e) {
          var $this = $(this);
          var isVtoPattern = Drupal.settings.vto.vto_patterns_products?.includes($this.closest('.js-product-vto-v1').data('productId'));

          if (!isVtoPattern || !currentSkuPcode) {
            return;
          }

          if (YMK && YMK.applyMakeupBySku) {
            YMK.applyMakeupBySku(currentSkuPcode, [$this.index()]);

            $this.addClass('active').siblings().removeClass('active');
            $this.attr('aria-pressed', 'true').siblings().attr('aria-pressed', 'false');
            self.updateArrowStates($that);
          }
        }
      );

      var $patternList = $that.nodes.$patternList;
      var $prevArrow = $('.js-product-vto-pattern-arrow-prev', $that);
      var $nextArrow = $('.js-product-vto-pattern-arrow-next', $that);

      $prevArrow.once().on('click', function () {
        var $active = $patternList.find('.js-product-vto-pattern-button.active');
        var $prev = $active.prev('.js-product-vto-pattern-button');

        if ($prev.length) {
          $prev.trigger('click');
          $prev[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        setTimeout(function () {
          self.updateArrowStates($that);
        }, 150);
      });

      $nextArrow.once().on('click', function () {
        var $active = $patternList.find('.js-product-vto-pattern-button.active');
        var $next = $active.next('.js-product-vto-pattern-button');

        if ($next.length) {
          $next.trigger('click');
          $next[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        setTimeout(function () {
          self.updateArrowStates($that);
        }, 150);
      });

      $patternList.once().on('scroll', function () {
        self.updateArrowStates($that);
      });

      $(document).on(
        'product.skuSelect',
        '.js-product-full',
        function (e, skuBaseId, $selectedShade) {
          var $this = $(this);
          // Update shadename
          skuBaseId = !skuBaseId ? $that.nodes.$product.data('skuBaseId') : skuBaseId;
          if ($that.nodes.$product.data('productId') === $this.data('productId')) {
            $that.nodes.$product.data('skuBaseId', skuBaseId).attr('data-sku-base-id', skuBaseId);
          } else {
            // BYOK has multiple product wrappers on the same page.
            return;
          }
          var skuData = prodcat.data.getSku(skuBaseId);
          var $shadeSwatch = $('.js-product-vto-shade-name', $that.nodes.$mobileShadePick);
          var $curMobSwatch = $that.nodes.$mobileSwatches.filter(
            '[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]'
          );
          var currentShadeIndex = $selectedShade ? $selectedShade.parent().data('index') : null;
          var isVtoPattern = $this.data('productId') && Drupal.settings.vto.vto_patterns_products?.includes($this.data('productId'));
          // Updated swatches
          $that.nodes.$mobileSwatches.removeClass('active');
          $that.nodes.$mobileSwatches.parent().removeClass('active');
          $curMobSwatch.addClass('active');
          if ($selectedShade) {
            $that.nodes.$desktopSwatches.removeClass('active');
            $that.nodes.$desktopSwatches.parent().removeClass('active');
            $selectedShade.hasClass('js-product-full_shade')
              ? null
              : $that.nodes.$desktopSwatches.first().parent().addClass('active');
            $selectedShade.parent().addClass('active');
            $selectedShade.addClass('active');
          }

          $shadeSwatch.html(skuData.SHADENAME);
          $shadeSwatch.css('color', skuData.HEX_VALUE_STRING);
          // Change the shade
          currentSkuPcode = skuData.PRODUCT_CODE;

          if (YMK && YMK.applyMakeupBySku) {
            var $activePattern = $that.nodes.$patternList.find('.js-product-vto-pattern-button.active');
            var patternVisible = !$('.js-product-vto__pattern-wrapper', $that).hasClass('hidden') && $activePattern.length;

            if (patternVisible) {
              YMK.applyMakeupBySku(currentSkuPcode, [$activePattern.index()]);
            } else if (currentShadeIndex !== null && currentShadeIndex !== undefined) {
              YMK.applyMakeupBySku(currentSkuPcode, [currentShadeIndex]);
            } else {
              YMK.applyMakeupBySku(currentSkuPcode);
            }
          }
          if (skuData.VTO_FLAG_ONLINE) {
            $that.nodes.$youcamButton.removeClass('hidden');
          } else {
            $that.nodes.$youcamButton.addClass('hidden');
          }

          self.updateArrowStates($that);
        }
      );

      $(document).bind('addToCart.success', function () {
        var addedText = $that.nodes.$addToBagContainer.data('added-text');
        var atbText = $that.nodes.$addToBag.html();

        $that.nodes.$addToBag.html(addedText);
        setTimeout(function () {
          $that.nodes.$addToBag.html(atbText);
        }, 3000);
      });

      $that.nodes.$mobileShadePicker.scroll(
        _.debounce(function () {
          var firstIsVis = self.isScrolledIntoViewHorizontal(
            $that,
            $firstSwatch,
            $that.nodes.$mobileShadePicker
          );
          var lastIsVis = self.isScrolledIntoViewHorizontal(
            $that,
            $lastSwatch,
            $that.nodes.$mobileShadePicker
          );
          var fullCarouselLength =
            $that.nodes.$mobileSwatches.length * $firstSwatch.outerWidth(true);

          if (fullCarouselLength <= $that.nodes.$mobileShadePicker.outerWidth(true)) {
            $that.nodes.$nextCar.addClass('hidden');
            $that.nodes.$prevCar.addClass('hidden');
          } else {
            if (firstIsVis && !lastIsVis) {
              // Hide prev. arrow
              $that.nodes.$prevCar.addClass('hidden');
              $that.nodes.$nextCar.removeClass('hidden');
            }
            if (!firstIsVis && !lastIsVis) {
              // Display both arrows
              $that.nodes.$nextCar.removeClass('hidden');
              $that.nodes.$prevCar.removeClass('hidden');
            }
            if (lastIsVis && !firstIsVis) {
              // Hide next arrow
              $that.nodes.$nextCar.addClass('hidden');
              $that.nodes.$prevCar.removeClass('hidden');
            }
          }
        }, 10)
      );

      $that.nodes.$prevCar
        .add($that.nodes.$nextCar)
        .once()
        .on('click', function (event) {
          var isShadeNext = $(event.target).hasClass('js-product-vto-shades-next');
          var shadeSwatchWidth = $that.nodes.$mobileSwatches.first().width();
          var scrollPosition = isShadeNext ? '+=' + shadeSwatchWidth : '-=' + shadeSwatchWidth;

          $that.nodes.$mobileShadePicker.animate({
            scrollLeft: scrollPosition
          });
        });
      $(document).on('open_vto', function () {
        self.openYoucamModule($that);
      });
    },
    reopenOnResize: function ($that) {
      window.YMK.closeEngine();
      window.YMK.close();
      $that.nodes.$ymkModuleCont.removeClass('hidden');
      $that.nodes.$productImages.addClass('vto-active');
      window.currentYMKcontext = $that;
      window.ymkAsyncInit();
      $that.nodes.$body.addClass('enable-vto');
    },
    renderHexCodesVTO: function ($that) {
      var self = this;

      var itemInlineTemplatePathMobile = 'product_vto_hex_codes_v1_MOBILE';
      var itemInlineTemplatePathPC = 'product_vto_hex_codes_v1_PC';
      var $inlineTemplateMobile = $(
        'script.inline-template[path="' + itemInlineTemplatePathMobile + '"]'
      ).html();
      var $inlineTemplatePC = $(
        'script.inline-template[path="' + itemInlineTemplatePathPC + '"]'
      ).html();

      $that.settings.productHexes = $that.settings.productHexes
        ? $that.settings.productHexes.toString().split(',')
        : null;
      if (
        $that.settings.productHexes &&
        $that.settings.productHexes.length > 0 &&
        ((self.isMobile && $that.nodes.$mobileShadePicker.children().length == 0) ||
          (!self.isMobile && $that.nodes.$shadesGrid.children().length == 0))
      ) {
        $that.settings.productHexes.forEach(function (hex, i) {
          $that.settings.productHexes[i] = {
            hex: hex.includes('#') ? hex : '#' + hex,
            index: i
          };
        });
        var templateData = { hexes: $that.settings.productHexes };

        desktopVTOShadesHTML = Mustache.render($inlineTemplatePC, templateData);
        mobileVTOShadesHTML = Mustache.render($inlineTemplateMobile, templateData);
        $that.nodes.$shadesContainer.html(desktopVTOShadesHTML);
        $that.nodes.$mobileShadePicker.html(mobileVTOShadesHTML);
      }
    },
    setup: function () {
      var self = this;
      self.autoTriggerYoucam = window.location.href.indexOf('vto_open') !== -1;
      self.hasVtoDiscloseParam = window.location.href.indexOf('vto_disclose') !== -1;
      var showCloseBtn = self.hasVtoDiscloseParam ? false : true;
      var language = Drupal.settings.vto.language;
      var vtoLanguageCaFr = Drupal.settings.vto_language_fr;
      var pageLanguage = $('html').attr('lang');
      var ykmWidth;
      var ymkHeight;
      var iframeHeight = 0;

      window.ymkAsyncInit = function () {
        var vtoParams;
        var $that = window.currentYMKcontext || $();
        var $vtoModule = $('.js-vto-module', $that);

        if ($that.length < 1) {
          return;
        }
        var minTabletHeight = 460;
        var $customKitWrapper = $that.nodes.$productFullImages.closest(
          '.js-custom-kit-product__product-image-container'
        );
        var isCr21 = Drupal.settings.globals_variables && Drupal.settings.globals_variables.cr21_spp;

        if (self.isMobile) {
          ykmWidth = $that.nodes.$productImages.find('.js-spp-carousel').width();
          $that.width(ykmWidth);
          vtoParams = {
            autoOpen: true,
            skinSmoothStrength: 17,
            showCloseBtnOnLauncher: showCloseBtn,
            width: ykmWidth || window.screen.width,
            height: iframeHeight || window.innerHeight,
            enableUserConsent: true
          };
          if (pageLanguage === 'fr') {
            vtoParams['language'] = vtoLanguageCaFr;
          } else if (language) {
            vtoParams['language'] = language;
          }
          window.YMK.init(vtoParams);
        } else {
          var thumbWidth = $that.nodes.$productImages
            .find('.js-product-thumbs:visible')
            .outerWidth(true);
          var slideWidth = $that.nodes.$productImages.find('.js-spp-carousel').width();
          // CR21 SPP doesn't use slider anymore, but we still have it on build ur own kit.
          let multiplierHeight = 1;
          // on build ur own kit, there are multiple image wrappers.
          // only work on the active one
          if ($that.nodes.$productFullImages.length > 1) {
            $that.nodes.$productFullImages = $that.nodes.$productFullImages.filter(function (
              i,
              element
            ) {
              return $(element).parents('.js-custom-kit-product').hasClass('active');
            });
          }
          multiplierHeight = $that.nodes.$productFullImages.find('.slick-slide').length > 0 ? 1 : 2;
          // Updated the width of SPP, caused the VTO to get an issue of Unsupported width & height
          // the content is reduced and centered to fix ASAP.
          if (isCr21) {
            ymkHeight =
              $that.nodes.$productFullImages.find('.js-product-slide').first().width() *
              multiplierHeight;
            ykmWidth =
              !self.isTablet || $customKitWrapper.length > 0
                ? $that.nodes.$productFullImages.width() - 30
                : $that.nodes.$productFullImages.width();
          } else {
            ymkHeight = $that.nodes.$productImages.find('.js-spp-carousel').height();
            ykmWidth = slideWidth - thumbWidth;
          }

          if (
            $customKitWrapper.length > 0 ||
            (self.isTablet && !self.isTabletLandscape && multiplierHeight > 1)
          ) {
            // If it's BYOK view, we keep the aspect ratio by increasing the height
            ymkHeight = ykmWidth * 1.2 > minTabletHeight ? ykmWidth * 1.2 : minTabletHeight;
            $customKitWrapper.css({ 'min-height': ymkHeight + 'px' });
          }

          if (ymkHeight < ykmWidth && $vtoModule.length && $vtoModule.height()) {
            ymkHeight = $('.js-vto-module').height();
          }

          if (!self.isTablet) {
            ymkHeight = ymkHeight > ykmWidth ? ykmWidth : ymkHeight;
          }

          $that.width(ykmWidth);
          vtoParams = {
            autoOpen: true,
            skinSmoothStrength: 17,
            showCloseBtnOnLauncher: showCloseBtn,
            width: ykmWidth,
            height: ymkHeight,
            enableUserConsent: true
          };
          if (pageLanguage === 'fr') {
            vtoParams['language'] = vtoLanguageCaFr;
          } else if (language) {
            vtoParams['language'] = language;
          }
          window.YMK.init(vtoParams);
        }
        if (self.skipEventListener) {
          return;
        }
        self.setYmkEvents();
      };
    },
    setYmkEvents: function () {
      var self = this;
      self.skipEventListener = true;
      var currentSkuPcode;
      var $that = window.currentYMKcontext || $();

      self.youcamEvents.forEach(function (event) {
        window.YMK.addEventListener(event, function (progress) {
          $that = window.currentYMKcontext || $();
          if (event === 'loaded') {
            // Add current sku
            var currentSkuBaseId = $that.nodes.$product.attr('data-sku-base-id');
            var skuData = prodcat.data.getSku(currentSkuBaseId);
            var $shadeHexItem = $that.nodes.$product.find('.js-shade-hex-item');
            var $selectedShade = $that.nodes.$mobileSwatches.filter(
              '[data-sku-base-id="' + currentSkuBaseId + '"]'
            );
            $selectedShade =
              $selectedShade.length == 0
                ? $that.nodes.$product.find('.js-product-vto-shade').first()
                : $selectedShade;
            $selectedShade.addClass('active');
            $shadeHexItem.first().addClass('active');

            var scrolltoLeft = 0;

            currentSkuPcode = skuData.PRODUCT_CODE;

            if (YMK && YMK.applyMakeupBySku) {
              $shadeHexItem.length > 0 && YMK?.applyMakeupBySku
                            ? YMK.applyMakeupBySku(currentSkuPcode, [0])
                            : YMK.applyMakeupBySku(currentSkuPcode);
            }

            $selectedShade.trigger('click');

            // Show pattern elements for VTO pattern products
            var $thisProductVTO = $that.nodes.$ymkModuleCont.closest('.js-product-vto-v1');
            var isVtoPattern = Drupal.settings.vto.vto_patterns_products?.includes($thisProductVTO.data('productId'));

            if (isVtoPattern) {
              $that.nodes.$currentPattern.removeClass('hidden');
              $that.nodes.$patternList.removeClass('hidden');
              $('.js-product-vto__pattern-wrapper', $that).removeClass('hidden');
              self.initCarousel($that);
            }

            if (self.isMobile) {
              $that.nodes.$mobileShadePicker.scrollLeft(scrolltoLeft);
              $that.nodes.$mobileShadePick.removeClass('hidden');
              window.YMK.changeSize({
                width: window.screen.width,
                height:
                  window.innerHeight -
                  $that.nodes.$mobileShadePick.filter(':visible').outerHeight(true) -
                  $that.nodes.$addToBagContainer.filter(':visible').outerHeight(true) -
                  10
              });
              var shadeOffsetLeft = 0;
              var shadeOuterWidth = 0;
              if ($selectedShade && $selectedShade.length) {
                var shadeOffset = $selectedShade.offset();
                if (shadeOffset && typeof shadeOffset.left === 'number') {
                  shadeOffsetLeft = shadeOffset.left;
                }
                var outerWidth = $selectedShade.outerWidth(true);
                if (typeof outerWidth === 'number') {
                  shadeOuterWidth = outerWidth;
                }
              }
              scrolltoLeft += shadeOffsetLeft;
              scrolltoLeft -= shadeOuterWidth / 2;
              $that.nodes.$mobileShadePicker.animate(
                {
                  scrollLeft: scrolltoLeft
                },
                350
              );
            }
          }

          if (event === 'opened' && self.autoTriggerYoucam && !isCr21) {
            $that.nodes.$youcamButton.addClass('hidden');
          }

          if (event === 'closed') {
            $that.nodes.$body.removeClass('vto-overlay-on');
            if (self.isMobile) {
              $that.nodes.$slideBagButton.removeClass('hidden');
              $that.nodes.$mobileShadePick.addClass('hidden');
              window.YMK.changeSize({
                width: window.screen.width,
                height: window.innerHeight
              });
              $that.nodes.$chatLiveButton.removeClass('hidden');
              $that.nodes.$stickyFooter.removeClass('hidden');
              $that.nodes.$product.trigger('product.updateRoute', currentSkuBaseId);
            }
            $that.nodes.$stickyNav.removeClass('mobile-hidden');
            $that.nodes.$ymkModuleCont.addClass('hidden');
            $that.nodes.$productImages.removeClass('vto-active');
            $that.nodes.$youcamButton.removeClass('hidden');
            $that.nodes.$body.removeClass('no-scroll enable-vto');
            // Reset pattern wrapper to initial state
            self.resetPatternCarousel($that);
            // Reset Product Thumb
            if (!self.isMobile) {
              $that.nodes.$productImages
                .find('.js-product-thumb.active:visible')
                .removeClass('active')
                .trigger('click');
            }
            window.YMK.closeEngine();
            if (self.hasVtoDiscloseParam) {
              self.openYoucamModule($that);
            }
          }
          // MTA-2587 - Analytics tagging for YouCam events - Starts
          var eventName;
          // Supressing multiple event tag fires during loading youcam event
          if (event === 'loading') {
            if (progress === 10) {
              eventName = 'loading-start';
            } else if (progress === 100) {
              eventName = 'loading-complete';
            }
          } else {
            eventName = event;
          }

          if (eventName === 'engineClosed' && self.isMobile) {
            $that.nodes.$mobileSwatches.closest('.js-product-vto-mobile-ctrl').addClass('hidden');
            window.YMK.changeSize({
              width: window.screen.width,
              height: window.innerHeight
            });
          }

          if (eventName === 'engineClosed') {
            $that.nodes.$shadesGrid.find('.js-shade-hex-item').length > 0
              ? $that.nodes.$shadesGrid.addClass('hidden')
              : null;
            self.resetPatternCarousel($that);
          }

          if (
            eventName === 'cameraOpened' ||
            eventName === 'photoLoaded' ||
            eventName === 'modelLoaded'
          ) {
            if (eventName === 'cameraOpened') {
              // Hide patterns container when camera is ready
              var $thisProductVTO = $that.nodes.$ymkModuleCont.closest('.js-product-vto-v1');
              var isVtoPattern = Drupal.settings.vto.vto_patterns_products?.includes($thisProductVTO.data('productId'));

              if (isVtoPattern) {
                $('.js-product-vto__pattern-wrapper', $that).addClass('hidden');
              }
            }
            $that.nodes.$shadesGrid.find('.js-shade-hex-item').length > 0
              ? $that.nodes.$shadesGrid
                  .removeClass('hidden')
                  .find('.js-shade-hex-item')
                  .removeClass('active')
              : null;
          }


          if (eventName) {
            // Unhide patterns container when camera is closed
            if (eventName === 'cameraClosed') {
              var $thisProductVTO = $that.nodes.$ymkModuleCont.closest('.js-product-vto-v1');
              var isVtoPattern = Drupal.settings.vto.vto_patterns_products?.includes($thisProductVTO.data('productId'));

              if (isVtoPattern) {
                $('.js-product-vto__pattern-wrapper', $that).removeClass('hidden');
              }
            }
            self.trackEvent($that, eventName);
          }
          // MTA-2587 - Analytics tagging for YouCam events - Ends
        }); // <-- closes the YMK event handler function
      }); // <-- closes the forEach

      if (self.autoTriggerYoucam) {
        self.openYoucamModule($that);
      }
    },
    checkDeviceType: function () {
      var self = this;

      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);
      var bPXlargeUp = parseInt(Unison.fetch.all()['usn-x-large'], 10);

      var hasMouse =
        matchMedia('(pointer:fine)').matches || $('html').hasClass('no-touch') || false;
      self.isMobile = currentBpWidth < bPlargeUp;
      self.isTablet = !self.isMobile && !hasMouse;
      self.isTabletLandscape = !hasMouse && currentBpWidth >= bPXlargeUp;
    },

    setOverlayDimensions: function ($that, ykmWidth) {
      var self = this;

      if (self.isMobile) {
        ykmWidth = $that.nodes.$productImages.find('.js-spp-carousel').width();
        $that.width(ykmWidth);
        $that.nodes.$ymkModuleCont.height($(window).height());
        $that.nodes.$chatLiveButton.removeClass('hidden');
        $that.nodes.$slideBagButton.removeClass('hidden');
      } else {
        var thumbWidth = $that.nodes.$productImages
          .find('.js-product-thumbs:visible')
          .outerWidth(true);
        var slideWidth = $that.nodes.$productImages.find('.js-spp-carousel').width();

        ykmWidth = slideWidth - thumbWidth;
        $that.width(ykmWidth);
      }
    },
    trackEvent: function ($that, eventName) {
      if (site && site.track) {
        var productName;
        var eventName;
        var eventLabel;
        var data = site.track.refreshData();
        var currentSkuBaseId = $that.nodes.$product.attr('data-sku-base-id');
        var skuData = prodcat.data.getSku(currentSkuBaseId);

        if (data && data.product_name && data.product_name.length) {
          productName = data.product_name[0].replace(/(<([^>]+)>)/gi, '');
          eventLabel = `${skuData.PRODUCT_ID} - ${skuData.SKU_ID} - ${productName}`;
        }

        site.track.evtLink({
          event_name: 'vto',
          event_category: 'vto',
          event_action: eventName,
          ...(eventLabel && { event_label: eventLabel }),
          vendor: 'youcam',
          vto_type: 'Makeup'
        });
      }
    },
    initCarousel: function ($that) {
      var $patternList = $that.nodes.$patternList;
      var $buttons = $patternList.find('.js-product-vto-pattern-button');

      if ($buttons.length === 0) {
        return;
      }

      // Always reset to first item
      $buttons.removeClass('active').attr('aria-pressed', 'false');
      $patternList.scrollLeft(0);
      $buttons.first().addClass('active').attr('aria-pressed', 'true');

      this.updateArrowStates($that);
    },
    resetPatternCarousel: function ($that) {
      var $patternList = $that.nodes.$patternList;
      var $buttons = $patternList.find('.js-product-vto-pattern-button');

      // Hide all pattern elements
      $('.js-product-vto__pattern-wrapper', $that).addClass('hidden');
      $that.nodes.$currentPattern.addClass('hidden');
      $that.nodes.$patternList.addClass('hidden');

      // Reset active states
      $buttons.removeClass('active').attr('aria-pressed', 'false');

      // Reset scroll position
      $patternList.scrollLeft(0);
    },
    updateArrowStates: function ($that) {
      var $patternList = $that.nodes.$patternList;
      var $prevArrow = $('.js-product-vto-pattern-arrow-prev', $that);
      var $nextArrow = $('.js-product-vto-pattern-arrow-next', $that);
      var $buttons = $patternList.find('.js-product-vto-pattern-button');
      var $active = $patternList.find('.js-product-vto-pattern-button.active');

      if ($buttons.length <= 1) {
        $prevArrow.prop('disabled', true);
        $nextArrow.prop('disabled', true);
        return;
      }

      if (!$active.length) {
        $buttons.first().addClass('active').attr('aria-pressed', 'true');
        $active = $buttons.first();
      }

      $prevArrow.prop('disabled', $active.is($buttons.first()));
      $nextArrow.prop('disabled', $active.is($buttons.last()));
    },
    openYoucamModule: function ($that) {
      var self = this;
      var isCr21 = Drupal.settings.globals_variables && Drupal.settings.globals_variables.cr21_spp;

      if (!self.hasVtoDiscloseParam) {
        window.YMK.closeEngine();
        window.YMK.close();
      }
      if (!isCr21) {
        $that.nodes.$youcamButton.addClass('hidden');
      }
      $that.nodes.$productImages.addClass('vto-active');
      $that.nodes.$ymkModuleCont.removeClass('hidden');
      self.autoTriggerYoucam = false;

      if (self.isMobile) {
        $that.nodes.$stickyNav.addClass('mobile-hidden');
        $that.nodes.$chatLiveButton.addClass('hidden');
        $that.nodes.$slideBagButton.addClass('hidden');
        $that.nodes.$stickyFooter.addClass('hidden');
        // Disable scrolling
        window.scrollTo(0, 0);
        $that.nodes.$body.addClass('no-scroll enable-vto');
      }
      window.currentYMKcontext = $that;
      window.ymkAsyncInit();
      $that.nodes.$body.addClass('vto-overlay-on');
    },
    isScrolledIntoViewHorizontal: function ($that, $el, $container) {
      var $firstSwatch = $that.nodes.$mobileSwatches.first();
      var elemLeft = $el.offset().left;
      var elemRight = elemLeft + $el.outerWidth(true);
      // Partially visible elements return true:
      var isVisible =
        elemRight > 1 &&
        Math.ceil(elemRight) < $container.outerWidth(true) + $firstSwatch.outerWidth(true);

      return isVisible;
    }
  };
})(jQuery);
